/**
 * @author Fernando Ruano
 * @file actions.js
 * @description S3File Actions
 */

// Constants
import {
  GET_ALL_S3_FILES,
  GET_S3_FILE_BY_KEY,
  UPLOAD_S3_FILE,
  DELETE_S3_FILE_BY_KEY
} from './constants';

/**
 * Call process to get all S3 files list
 * @param  { object } data - Pagination Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_S3_FILES
 */
export const getS3FilesArray = (data, callback) => ({
  type: GET_ALL_S3_FILES,
  payload: { data },
  callback
});

/**
 * Call process to get S3 File by key
 * @param  { object } data - S3File Id
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_S3_FILE_BY_KEY
 */
export const getS3FileByKey = (data, callback) => ({
  type: GET_S3_FILE_BY_KEY,
  payload: { data },
  callback
});

/**
 * Call process to upload file
 * @param  { object } data - S3File Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of UPLOAD_S3_FILE
 */
export const uploadS3File = (data, callback) => ({
  type: UPLOAD_S3_FILE,
  payload: { data },
  callback
});

/**
 * Call process to delete s3 file
 * @param  { object } data - S3File Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of DELETE_S3_FILE_BY_KEY
 */
export const deleteS3FileByKey = (data, callback) => ({
  type: DELETE_S3_FILE_BY_KEY,
  payload: { data },
  callback
});
